function transformPoint(
  {x, y, z = 0}: {x: number; y: number; z?: number},
  matrix: DOMMatrix,
): DOMPoint {
  let resX = x * matrix.m11 + y * matrix.m21 + z * matrix.m31 + matrix.m41;
  let resY = x * matrix.m12 + y * matrix.m22 + z * matrix.m32 + matrix.m42;
  let resZ = x * matrix.m13 + y * matrix.m23 + z * matrix.m33 + matrix.m43;
  const resW = x * matrix.m14 + y * matrix.m24 + z * matrix.m34 + matrix.m44;

  if (resW != 1) {
    resX /= resW;
    resY /= resW;
    resZ /= resW;
  }

  return new DOMPoint(resX, resY, resZ, resW);
}

export default transformPoint;
